module.exports = __webpack_public_path__ + "img/892003111.a9502425.png";